import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SelectedDeviceService } from './selected-device.service';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root'
})
export class SelectedDeviceGuard  {

  public constructor(
    private router: Router,
    private selectedDeviceService: SelectedDeviceService,
    public resourceService: ADPResourceService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.selectedDeviceService.getSelectedDevice() == null) {
      return this.router.parseUrl(this.resourceService.getPortalSetting("URL_MyDevices").Value);
    }

    return true;
  }

}
